<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group ts-whitespace-no-wrap">
        <div class="col-md-4 d-flex align-items-end">
          <div class="ts-inline-block ts-text-xs mr-2">
            <ts-checkbox v-model="model.is_percentage">
              {{ $t('subjectGradingRange.percentage') }}
            </ts-checkbox>
          </div>
          <div class="ts-inline-block ts-text-xs">
            <ts-checkbox
              v-model="model.enable_semester"
              @change="enableSemester"
              >{{ $t('subjectGradingRange.enableSemester') }}</ts-checkbox
            >
          </div>
          <div class="ts-inline-block ts-text-xs ml-2">
            <ts-checkbox
              v-model="model.enable_sciense"
              @change="enableSciense"
              >{{ $t('subjectGradingRange.enableSciense') }}</ts-checkbox
            >
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <div
            class="ts-border ts-rounded ts-border-gray-200 ts-border-opacity-20 ts-p-3"
          >
            <label class="required ts-text-xs">
              {{ $t('subjectGradingRange.scoreList') }}
            </label>
            <table class="table table-hover ui-table">
              <thead>
                <tr>
                  <th class="ts-text-xs ts-whitespace-no-wrap">
                    {{ $t('subjectGradingRange.grading') }}
                  </th>
                  <th class="ts-text-xs">
                    {{ $t('subjectGradingRange.minScore') }}
                  </th>
                  <th class="ts-text-xs">
                    {{ $t('subjectGradingRange.maxScore') }}
                  </th>
                  <th class="ts-text-xs">
                    {{ $t('subjectGradingRange.minScoreSemester') }}
                  </th>
                  <th class="ts-text-xs">
                    {{ $t('subjectGradingRange.maxScoreSemester') }}
                  </th>
                  <th class="ts-text-xs ts-whitespace-no-wrap">
                    {{ $t('subjectGradingRange.minScoreSciense') }}
                  </th>
                  <th class="ts-text-xs ts-whitespace-no-wrap">
                    {{ $t('subjectGradingRange.maxScoreSciense') }}
                  </th>
                  <th class="ts-text-xs">
                    {{ $t('subjectGradingRange.pass') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in model.subject_score_grading_list"
                  :key="index"
                >
                  <td class="text-left ts-text-xs" valign="middle">
                    <input
                      type="text"
                      :value="item.grade"
                      readonly
                      class="form-control"
                      style="width:40px"
                    />
                  </td>
                  <td>
                    <input
                      v-model.number="item.score_start"
                      type="number"
                      class="form-control"
                    />
                    <div
                      class="validate ts-text-xs"
                      v-if="
                        errors.has(
                          'subject_score_grading_list.' + index + '.score_start'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'subject_score_grading_list.' + index + '.score_start'
                        )
                      }}
                    </div>
                  </td>
                  <td>
                    <input
                      v-model.number="item.score_stop"
                      type="number"
                      class="form-control"
                    />
                    <div
                      class="validate ts-text-xs"
                      v-if="
                        errors.has(
                          'subject_score_grading_list.' + index + '.score_stop'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'subject_score_grading_list.' + index + '.score_stop'
                        )
                      }}
                    </div>
                  </td>
                  <td>
                    <input
                      v-model.number="item.semester_score_start"
                      :disabled="!model.enable_semester"
                      type="number"
                      class="form-control"
                    />
                    <div
                      class="validate ts-text-xs"
                      v-if="
                        errors.has(
                          'subject_score_grading_list.' +
                            index +
                            '.semester_score_start'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'subject_score_grading_list.' +
                            index +
                            '.semester_score_start'
                        )
                      }}
                    </div>
                  </td>
                  <td>
                    <input
                      v-model.number="item.semester_score_stop"
                      :disabled="!model.enable_semester"
                      type="number"
                      class="form-control"
                    />
                    <div
                      class="validate ts-text-xs"
                      v-if="
                        errors.has(
                          'subject_score_grading_list.' +
                            index +
                            '.semester_score_stop'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'subject_score_grading_list.' +
                            index +
                            '.semester_score_stop'
                        )
                      }}
                    </div>
                  </td>
                  <td>
                    <input
                      v-model.number="item.sciense_score_start"
                      :disabled="!model.enable_sciense"
                      type="number"
                      class="form-control"
                    />
                    <div
                      class="validate ts-text-xs"
                      v-if="
                        errors.has(
                          'subject_score_grading_list.' +
                            index +
                            '.sciense_score_start'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'subject_score_grading_list.' +
                            index +
                            '.sciense_score_start'
                        )
                      }}
                    </div>
                  </td>
                  <td>
                    <input
                      v-model.number="item.sciense_score_stop"
                      :disabled="!model.enable_sciense"
                      type="number"
                      class="form-control"
                    />
                    <div
                      class="validate ts-text-xs"
                      v-if="
                        errors.has(
                          'subject_score_grading_list.' +
                            index +
                            '.sciense_score_stop'
                        )
                      "
                    >
                      {{
                        errors.first(
                          'subject_score_grading_list.' +
                            index +
                            '.sciense_score_stop'
                        )
                      }}
                    </div>
                  </td>
                  <td>
                    <ts-checkbox v-model="item.is_pass"></ts-checkbox>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 text-right">
          <ts-button class="mr-2" @click.prevent="$emit('close')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            class="mr-2"
            color="primary"
            @click.prevent="onUpdate"
            :waiting="waiting"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import Academic from './component/academic'
import SubjectGrading from './component/subject-grading'

export default {
  name: 'subjectGradingFormEdit',
  props: ['resource'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      gradeDefinitions: [],
      subjects: [],
      waiting: false,
      model: {
        is_percentage: false,
        enable_sciense: false,
        enable_semester: false,
        subject_score_grading_list: []
      },
      sendData: {
        subject_score_grading_list: []
      }
    }
  },
  created() {
    this.fetchEdit()
  },
  methods: {
    ...mapActions('subjectGradingRange', ['getEditData', 'update']),
    enableSemester() {
      this.model.subject_score_grading_list.forEach(el => {
        el.semester_score_start = null
        el.semester_score_stop = null
      })
    },
    enableSciense() {
      this.model.subject_score_grading_list.forEach(el => {
        el.sciense_score_start = null
        el.sciense_score_stop = null
      })
    },
    fetchEdit() {
      this.loading = true
      this.model.is_percentage = this.resource.is_percentage
      this.model.enable_semester = this.resource.enable_semester
      this.model.enable_sciense = this.resource.enable_sciense

      this.getEditData(this.resource.grade_subject_id)
        .then(response => {
          this.model.subject_score_grading_list = response.data
            .map(el => ({
              grade_subject_grading_id: el.grade_subject_grading_id,
              grade_subject_id: el.grade_subject_id,
              score_start: el.score_start,
              score_stop: el.score_stop,
              semester_score_start: el.semester_score_start,
              semester_score_stop: el.semester_score_stop,
              sciense_score_start: el.sciense_score_start,
              sciense_score_stop: el.sciense_score_stop,
              grade_definition_id: el.grade_definition_id,
              is_pass: el.is_pass,
              grade: el.grading_definition.grade
            }))
            .sort((a, b) => {
              return a.grade_definition_id - b.grade_definition_id
            })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.update({
        id: this.resource.grade_subject_grading_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
          this.$emit('fetch')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
.table > thead > tr > th {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  align-items: center;
}
</style>
